// here we store types not auto-generated (like supabase.ts)
import { Database } from '@/types/supabase';

// MARK: users
export type Sector = Database['public']['Tables']['sector']['Row'];
export type Organization = Database['public']['Tables']['organization']['Row'];

export type OrganizationFull = Organization & {
  sector: Sector;
};

export type OrganizationOverview = OrganizationFull & {
  teams: (Team & { users: Profile[] })[];
};

export type Team = Database['public']['Tables']['team']['Row'];
export type TeamFull = Team & {
  organization: OrganizationFull;
};

// extend the Profile row with possible team information
export type Profile = Database['public']['Tables']['profiles']['Row'];

// MARK: samen (HnH groups)
export interface Samen {
  id: string;
  name: string;
  avatar_url: string | null;
  created_at: string;
  updated_at: string;
}

export interface SamenMeditation {
  id: string;
  samen_id: string;
  created_by: string;
  meditation_title: string;
  scheduled_at: string;
  duration_minutes: number;
  image_url: string | null;
  activity_type: string;
  created_at: string;
}

/**
 * Enriched user profile.
 * Containing team membership.
 */
export type ProfileFull = Profile & {
  role?: UserRoleType;
  teams: TeamFull[];
  samen?: Samen | null; // HnH samen group (for hoofdhartuser)
  // track which team the user is currently "viewing" in the frontend
  active_team_idx?: number; // e.g. 0 (or -1 when no available)
};

export type UserRoleType = Database['public']['Enums']['user_role'];

export const UserRole: UserRoleType = 'user';
export const AdminRole: UserRoleType = 'admin';

// MARK: content
export type Content = Database['public']['Tables']['content']['Row'];

export type ContentConfig =
  Database['public']['Tables']['content_configs']['Row'];
export type ContentConfigInsert =
  Database['public']['Tables']['content_configs']['Insert'];

export interface ContentWithConfig {
  content: Content;
  configs: ContentConfig[];
  keywords?: KeywordWithSynonyms[];
}

export type Keyword = Database['public']['Tables']['keywords']['Row'];

// legacy interface from use-keywords.ts
export type KeywordWithSynonyms = Keyword & {
  synonyms?: string[];
  synonymsData?: any[];
};

// ContentConfig with or without an ID
export type ContentConfigEditOrInsert = ContentConfig | ContentConfigInsert;

export type ContentType = Database['public']['Enums']['content_type'];

// export const CONTENT_TYPES: Map[ContentType, String] = {

export type AUDIO_TYPE = 'music' | 'voice';

export type Activity = Database['public']['Tables']['activity']['Row'];
